import { Component, OnInit, HostListener, Input } from '@angular/core';
import { UserService } from '../../services/user-service/user.service';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LucideAngularModule, ShoppingCart, Search, LogIn, User, FlaskConical, Menu, ChevronRight } from 'lucide-angular';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, NavigationEnd, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NotificationContainerComponent } from '../notification-container/notification-container.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    LucideAngularModule, CommonModule, NotificationContainerComponent, RouterLink
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isAuthenticated = false;
  userName = '';
  isScrolled = false;
  isMobileMenuOpen = false;
  readonly ShoppingCartIcon = ShoppingCart;
  readonly SearchIcon = Search;
  readonly LoginIcon = LogIn;
  readonly UserIcon = User;
  readonly FlaskIcon = FlaskConical;
  readonly MenuIcon = Menu;
  readonly ChevronRightIcon = ChevronRight;
  readonly logo = `${environment.API_ENDPOINT}/assets/logo.png`;

  @Input() cartCount: number = 0;

  tinyHeaderPages = [
    "shop/:productId",
  ];
  tinyHeader: boolean = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {

    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        // Wait a moment for view to render
        setTimeout(() => {
          const el = document.getElementById(fragment);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100); // Adjust delay if needed
      }
    });



    const userState = this.userService.getUserState();
    this.isAuthenticated = userState.isAuthenticated;
    this.userName = userState.userData?.name || '';
    console.log('User:', this.userName);

    // Subscribe to router events to detect route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkIfTinyHeaderRequired();
    });

    // Check on initial load
    this.checkIfTinyHeaderRequired();
  }

  checkIfTinyHeaderRequired(): void {
    const currentUrl = this.router.url;

    // Check if the current URL matches the pattern "shop/something"
    if (currentUrl.match(/\/shop\/[\w-]+$/)) {
      this.tinyHeader = true;
    } else {
      this.tinyHeader = false;
    }

    console.log('Current URL:', currentUrl, 'Tiny Header:', this.tinyHeader);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 20;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    document.body.classList.toggle('no-scroll', this.isMobileMenuOpen);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    document.body.classList.remove('no-scroll');
  }

  navigateToCart(){
    this.closeMobileMenu();
    this.router.navigate(['user','cart'])
  }

  onLogin(){
    this.closeMobileMenu();
    this.router.navigate(['login'])
  }
  onProfile(){
    this.router.navigate(['user','profile'])
  }
  onLogout(){
    this.router.navigate(['logout'])
  }

  navigateToHome(fragment: string) {
    this.router.navigate(['/'], { fragment: fragment });
  }
}

